const e = {
  Summary: "SUMMARY",
  Detailed: "DETAILED"
};
export {
  e as Projection
};
//# sourceMappingURL=Projection.js.map
